export enum Language {
  CAT = 'CAT',
  VAL = 'VAL',
  ESP = 'ESP',
  MEX = 'MEX',
  ECU = 'ECU',
  EUSK = 'EUSK',
  ENG = 'ENG',
}

export type LanguageType = `${Language}`;
